// GoToCoordinates.js
import Overlay from 'ol/Overlay';
import { map } from './Map';
import { setFloatingControlsVisible, closeSidebarOnMobile } from './CustomFunctions';
import { CoordinateService } from './CoordinateService'; // استيراد الخدمة المركزية

let coordinateMarker = null;

function ensureCoordinateSection() {
    const container = $('#gpsSectionContent');
    if (container.children().length > 0) return;

    container.html(`
        <div class="coordinate-control-group">
            <style>
                .coordinate-control-group {
                    background: var(--bg-card);
                    border: 1px solid var(--border-color);
                    border-radius: var(--radius-lg);
                    padding: 20px;
                    transition: all var(--transition-normal);
                }
                .coordinate-system-tabs {
                    display: flex;
                    gap: 8px;
                    margin-bottom: 20px;
                    background: var(--btn-ghost-bg);
                    padding: 6px;
                    border-radius: var(--radius-md);
                }
                .coord-tab {
                    flex: 1;
                    border: none;
                    padding: 10px;
                    border-radius: var(--radius-sm);
                    cursor: pointer;
                    transition: all var(--transition-normal);
                    font-weight: 700;
                    font-family: var(--font-display);
                    background: transparent;
                    color: var(--text-secondary);
                }
                .coord-tab.active {
                    background: var(--bg-primary);
                    color: var(--primary);
                    box-shadow: var(--shadow-sm);
                }
                [data-theme="dark"] .coord-tab.active {
                    background: var(--primary-light);
                    color: var(--primary);
                    box-shadow: 0 4px 12px var(--primary-glow);
                }
                .coordinate-input-group label {
                    display: block;
                    margin-bottom: 8px;
                    font-weight: 600;
                    color: var(--text-primary);
                    font-size: 0.85rem;
                }
                .coordinate-input {
                    width: 100%;
                    padding: 12px 16px;
                    background: var(--input-bg);
                    border: 2px solid var(--border-color);
                    border-radius: var(--radius-md);
                    color: var(--text-primary);
                    font-family: inherit;
                    font-size: 0.95rem;
                    transition: all var(--transition-normal);
                    text-align: left;
                    direction: ltr; /* coordinates usually ltr */
                }
                .coordinate-input:focus {
                    border-color: var(--primary);
                    box-shadow: 0 0 0 3px var(--primary-light);
                    outline: none;
                }
                .input-error {
                    border-color: var(--primary) !important;
                    background-color: var(--primary-light) !important;
                }
                .coordinate-checkbox-group label {
                    color: var(--text-primary);
                    font-weight: 600;
                    font-size: 0.9rem;
                }
                .coordinate-btn {
                    padding: 14px;
                    border-radius: var(--radius-md);
                    font-weight: 700;
                    font-size: 0.95rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    transition: all var(--transition-normal);
                    border: none;
                }
                .coordinate-btn-primary {
                    background: var(--gradient-primary);
                    color: #fff;
                    box-shadow: 0 4px 12px var(--primary-glow);
                }
                .coordinate-btn-secondary {
                    background: var(--btn-ghost-bg);
                    color: var(--text-secondary);
                    border: 1px solid var(--border-color);
                }
                .coordinate-btn-danger {
                    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
                    color: #fff;
                }
                @media (hover: hover) {
                    .coordinate-btn:hover {
                        transform: translateY(-2px);
                    }
                    .coordinate-btn-primary:hover {
                        box-shadow: 0 6px 20px var(--primary-glow);
                    }
                }
            </style>
            
            <div class="section-header">
                <span>الذهاب إلى الإحداثيات</span>
                <i class="fas fa-crosshairs"></i>
            </div>

            <div class="coordinate-system-tabs">
                <button class="coord-tab active" data-system="local">Palestine Grid</button>
                <button class="coord-tab" data-system="wgs84">World Grid</button>
            </div>

            <div id="localInputGroup">
                <div class="coordinate-input-group">
                    <label for="xCoordinate">الإحداثي X (شرق):</label>
                    <input type="number" id="xCoordinate" class="coordinate-input" placeholder="مثال: 174762" step="any">
                </div>
                <div class="coordinate-input-group" style="margin-top: 15px;">
                    <label for="yCoordinate">الإحداثي Y (شمال):</label>
                    <input type="number" id="yCoordinate" class="coordinate-input" placeholder="مثال: 180836" step="any">
                </div>
            </div>

            <div id="wgsInputGroup" style="display: none;">
                <div class="coordinate-input-group">
                    <label for="latCoordinate">خط العرض (Latitude):</label>
                    <input type="number" id="latCoordinate" class="coordinate-input" placeholder="مثال: 32.2291" step="any">
                </div>
                <div class="coordinate-input-group" style="margin-top: 15px;">
                    <label for="lonCoordinate">خط الطول (Longitude):</label>
                    <input type="number" id="lonCoordinate" class="coordinate-input" placeholder="مثال: 35.2662" step="any">
                </div>
            </div>

            <div class="coordinate-input-group" style="margin-top: 15px;">
                <label for="zoomLevel">مستوى التكبير:</label>
                <select id="zoomLevel" class="coordinate-input" style="direction: rtl; text-align: right;">
                    <option value="6">عام (6)</option>
                    <option value="9">منطقة (9)</option>
                    <option value="11" selected>قطع أراضي (11)</option>
                    <option value="13">تفصيلي (13)</option>
                </select>
            </div>
            
            <div class="coordinate-checkbox-group" style="margin: 20px 0;">
                <label class="checkbox-container" style="display: flex; align-items: center; gap: 10px; cursor: pointer;">
                    <input type="checkbox" id="showMarker" checked style="width: 20px; height: 20px; accent-color: var(--primary);">
                    <span>عرض علامة على الموقع</span>
                </label>
            </div>
            
            <div class="control-buttons" style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
                <button class="coordinate-btn coordinate-btn-primary" id="goToCoordinates">
                    <i class="fas fa-location-arrow"></i> اذهب
                </button>
                <button class="coordinate-btn coordinate-btn-secondary" id="clearCoordinates">
                    <i class="fas fa-eraser"></i> مسح
                </button>
            </div>
            <button class="coordinate-btn coordinate-btn-danger" id="removeMarker" style="width: 100%; margin-top: 12px;">
                <i class="fas fa-trash"></i> إزالة العلامة
            </button>
        </div>
    `);

    $('.coord-tab').click(function () {
        $('.coord-tab').removeClass('active');
        $(this).addClass('active');
        const system = $(this).data('system');
        if (system === 'local') {
            $('#localInputGroup').show();
            $('#wgsInputGroup').hide();
        } else {
            $('#localInputGroup').hide();
            $('#wgsInputGroup').show();
        }
    });

    $('#goToCoordinates').click(goToCoordinates);
    $('#clearCoordinates').click(() => {
        ['xCoordinate', 'yCoordinate', 'latCoordinate', 'lonCoordinate'].forEach(id => {
            const el = document.getElementById(id);
            if (el) el.value = '';
        });
    });
    $('#removeMarker').click(removeMarker);
}

function createMarker(coordinates) {
    removeMarker();
    const markerElement = document.createElement('div');
    markerElement.className = 'coordinate-marker';
    markerElement.innerHTML = `
        <div class="marker-icon"><i class="fas fa-map-pin"></i></div>
        <div class="marker-pulse"></div>
    `;

    coordinateMarker = new Overlay({
        position: coordinates,
        positioning: 'bottom-center',
        element: markerElement,
        stopEvent: false
    });

    map.addOverlay(coordinateMarker);
}

function removeMarker() {
    if (coordinateMarker) {
        map.removeOverlay(coordinateMarker);
        coordinateMarker = null;
    }
}

function showCoordinateError(message) {
    const existingError = document.querySelector('.coordinate-error-message');
    if (existingError) existingError.remove();

    const errorDiv = document.createElement('div');
    errorDiv.className = 'coordinate-error-message';
    errorDiv.innerHTML = `
        <div class="coordinate-error-content">
            <i class="fas fa-exclamation-triangle"></i>
            <span>${message}</span>
            <button class="coordinate-error-close"><i class="fas fa-times"></i></button>
        </div>
    `;

    document.body.appendChild(errorDiv);
    errorDiv.querySelector('.coordinate-error-close').addEventListener('click', () => errorDiv.remove());
    setTimeout(() => { if (errorDiv.parentNode) errorDiv.remove(); }, 5000);

    // تمييز الحقول الخاطئة
    const activeSystem = $('.coord-tab.active').data('system');
    if (activeSystem === 'local') {
        const xInput = document.getElementById('xCoordinate');
        const yInput = document.getElementById('yCoordinate');
        if (isNaN(parseFloat(xInput.value))) xInput.classList.add('input-error');
        if (isNaN(parseFloat(yInput.value))) yInput.classList.add('input-error');
        setTimeout(() => { xInput.classList.remove('input-error'); yInput.classList.remove('input-error'); }, 3000);
    } else {
        const latInput = document.getElementById('latCoordinate');
        const lonInput = document.getElementById('lonCoordinate');
        if (isNaN(parseFloat(latInput.value))) latInput.classList.add('input-error');
        if (isNaN(parseFloat(lonInput.value))) lonInput.classList.add('input-error');
        setTimeout(() => { latInput.classList.remove('input-error'); lonInput.classList.remove('input-error'); }, 3000);
    }
}

function goToCoordinates() {
    closeSidebarOnMobile();

    const activeSystem = $('.coord-tab.active').data('system');
    const zoom = parseInt(document.getElementById('zoomLevel').value);
    const showMarkerCheck = document.getElementById('showMarker');

    let coordinates = null;

    if (activeSystem === 'local') {
        const x = parseFloat(document.getElementById('xCoordinate').value);
        const y = parseFloat(document.getElementById('yCoordinate').value);

        if (isNaN(x) || isNaN(y)) {
            showCoordinateError('يرجى إدخال قيم صحيحة للإحداثيات المحلية');
            return;
        }

        const validation = CoordinateService.validateInExtent(x, y);
        if (!validation.valid) {
            showCoordinateError(validation.message);
            return;
        }
        coordinates = [x, y];
    } else {
        const lat = parseFloat(document.getElementById('latCoordinate').value);
        const lon = parseFloat(document.getElementById('lonCoordinate').value);

        if (isNaN(lat) || isNaN(lon)) {
            showCoordinateError('يرجى إدخال قيم صحيحة لخطوط العرض والطول');
            return;
        }

        const validation = CoordinateService.validateWGS84(lat, lon);
        if (!validation.valid) {
            showCoordinateError(validation.message);
            return;
        }
        coordinates = validation.localCoords;
    }

    try {
        map.getView().animate({ center: coordinates, zoom: zoom, duration: 1000 });
        if (showMarkerCheck.checked) createMarker(coordinates);

        setTimeout(() => {
            const successDiv = document.createElement('div');
            successDiv.className = 'coordinate-success-message';
            successDiv.innerHTML = `<i class="fas fa-check-circle"></i> تم الانتقال إلى الموقع بنجاح`;
            document.body.appendChild(successDiv);
            setTimeout(() => successDiv.remove(), 3000);
        }, 1000);

    } catch (error) {
        console.error('خطأ في الانتقال إلى الإحداثيات:', error);
        showCoordinateError('حدث خطأ أثناء الانتقال إلى الإحداثيات');
    }
}

function initGoToCoordinates() {
    $('#gpsTool').off('click').on('click', function (e) {
        e.preventDefault();
        const section = $('#gpsSection');
        const button = $(this);

        if (button.hasClass('active')) {
            section.slideUp(200);
            button.removeClass('active');
        } else {
            ensureCoordinateSection();
            section.slideDown(200);
            button.addClass('active');
            setTimeout(() => {
                const xInput = document.getElementById('xCoordinate');
                if (xInput) xInput.focus();
            }, 300);
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.ctrlKey && e.key === 'g') {
            e.preventDefault();
            $('#gpsTool').click();
        }
    });
}

export { initGoToCoordinates, removeMarker };
initGoToCoordinates();